let navDropdownItems = $('.menu-item.is-dropdown');

$('.site-header-row-two .menu-item').on('click', function(e) {
    e.stopPropagation();
});

navDropdownItems.each(function(e) {
    let dropdownMenuItem = $(this),
        dropdown = dropdownMenuItem.find('.dropdown-container'),
        dropdownLink = dropdownMenuItem.find('> a');

    dropdownLink.on('click', function(e) {
        e.preventDefault();
        if(dropdownMenuItem.hasClass('is-showing')) {
            dropdownMenuItem.removeClass('is-showing');
            setTimeout(function () {
                dropdownMenuItem.addClass('is-hidden');
            }, 301);
        } else {
            closeDropdowns();

            dropdownMenuItem.removeClass('is-hidden');
            setTimeout(function () {
                dropdownMenuItem.addClass('is-showing');
            }, 1);
        }
    });

    $(this).on('click', function(e) {
        e.stopPropagation();
    });

    let subMenuItems = dropdown.find('.is-dropdown');

    subMenuItems.each(function() {
        let subMenuItem = $(this),
            subMenu = subMenuItem.find('.dropdown-sub-container'),
            subMenuLink = subMenuItem.find('> a');

        subMenuLink.on('click', function(e) {
            e.preventDefault();
            subMenu.slideToggle();
            subMenuItem.toggleClass('is-active');
        });
    });
});

// $('.dropdown-container a').on('click', function(e) {
//     e.stopPropagation();
// });

function closeDropdowns() {
    let otherDropdowns = $('.menu-item.is-showing');
    if(otherDropdowns.length > 0) {
        otherDropdowns.removeClass('is-showing');
        setTimeout(function () {
            otherDropdowns.addClass('is-hidden');
        }, 301);
    }
}

$(document).on('click', function(e) {
    closeDropdowns();
});


let mobileNavOpenButton = $('#mobile-nav-open'),
    mobileNavCloseButton = $('#mobile-nav-close'),
    mobileNav = $('#site-navigation');

mobileNavOpenButton.on('click', function(e) {
    e.preventDefault();
    openMobileNav();
});

mobileNavCloseButton.on('click', function(e) {
    e.preventDefault();
    closeMobileNav();
});

function openMobileNav() {
    mobileNav.addClass('is-active');
    setTimeout(function() {
        mobileNav.addClass('is-showing');
    }, 1);
}

function closeMobileNav() {
    mobileNav.removeClass('is-showing');
    setTimeout(function() {
        mobileNav.removeClass('is-active');
    }, 301);
}

// Escape closes the innermost open menu and returns focus to the control that
// opened it. Focus has to move synchronously, before the 301ms timeouts hide
// the container, or the browser drops focus to <body>.
$(document).on('keydown', function(e) {
    if(e.key !== 'Escape' && e.keyCode !== 27) {
        return;
    }

    if(mobileNav.hasClass('is-active')) {
        closeMobileNav();
        mobileNavOpenButton.trigger('focus');
        return;
    }

    let openSubMenu = $(document.activeElement).closest('.is-dropdown.is-active');
    if(openSubMenu.length > 0) {
        openSubMenu.find('> .dropdown-sub-container').slideUp();
        openSubMenu.removeClass('is-active');
        openSubMenu.find('> a').trigger('focus');
        return;
    }

    let openDropdown = $('.menu-item.is-showing');
    if(openDropdown.length > 0) {
        closeDropdowns();
        openDropdown.first().find('> a').trigger('focus');
    }
});
